// other — the approved primary lockup ("other" over "merch. paper. gifts.").
//
// Vector artwork approved 2026-10-07 (Other-Vector-Art: outlined shapes, no
// font). Never typeset or redrawn. Black on light surfaces; the reversed
// white file over dark ones. 106px wide is the header size.
interface LogoProps {
  /** "white" = reversed artwork for dark surfaces; "secondary" kept for old callers. */
  variant?: "primary" | "secondary" | "white";
  className?: string;
}

export function Logo({ variant = "primary", className }: LogoProps) {
  return (
    <img
      src={variant === "white" ? "/brand/other-primary-lockup-white.svg" : "/brand/other-primary-lockup-black.svg"}
      width={106}
      height={44}
      alt="other — merch. paper. gifts."
      className={className}
      // Never stretched: the lockup keeps its own proportions in any box.
      style={{ objectFit: "contain", objectPosition: "left center" }}
      draggable={false}
    />
  );
}
